/** 商品档案打印模版：展示文字，库存 temperature_zone 存 ID */
export const PRODUCT_PRINT_TEMPLATE_OPTIONS = [
  { id: '1', label: '常温/冷藏库' },
  { id: '2', label: '冷冻库' },
  { id: '3', label: '按客户投框' }
]

const BY_ID = PRODUCT_PRINT_TEMPLATE_OPTIONS.reduce((m, o) => {
  m[o.id] = o.label
  return m
}, {})

const BY_LABEL = PRODUCT_PRINT_TEMPLATE_OPTIONS.reduce((m, o) => {
  m[o.label] = o.id
  return m
}, {})

/** 导入/历史值 → 存储 ID */
export function normalizePrintTemplateId (raw) {
  if (raw == null || raw === '') return undefined
  const text = String(raw).trim()
  if (BY_ID[text]) return text
  if (BY_LABEL[text]) return BY_LABEL[text]
  const lower = text.toLowerCase()
  if (lower === 'ambient') return '1'
  if (lower === 'frozen') return '2'
  if (lower === 'customer') return '3'
  if (text.includes('投框') || text.includes('按客户')) return '3'
  if (text === '冷冻' || lower === 'frozen' || text.includes('冷冻')) return '2'
  if (text === '常温' || text === '冷藏' || text.includes('常温') || text.includes('冷藏')) return '1'
  return undefined
}

/** 存储 ID 或历史文本 → 展示名称 */
export function printTemplateLabel (stored) {
  if (stored == null || stored === '') return '—'
  const id = normalizePrintTemplateId(stored)
  if (id && BY_ID[id]) return BY_ID[id]
  return String(stored).trim() || '—'
}
